import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["checkbox", "submitButton"];

  connect() {
    this.updateSubmitButton();
  }

  updateCount() {
    this.updateSubmitButton();
  }

  updateSubmitButton() {
    const checkedCount = this.checkboxTargets.filter(cb => cb.checked).length;
    
    if (checkedCount > 0) {
      this.submitButtonTarget.textContent = `Add ${checkedCount} Object${checkedCount !== 1 ? 's' : ''}`;
      this.submitButtonTarget.disabled = false;
    } else {
      this.submitButtonTarget.textContent = 'Add Selected Objects';
      this.submitButtonTarget.disabled = true;
    }
  }
}

